import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Pipe({
    name: 'asset'
})
export class AssetPipe implements PipeTransform {
    transform(path: string): string {
        const version = (window as any).videoPlayerVersion;

        return environment.assetsCdnUrl
      + (version ? `/${version}` : '')
      + path;
    }
}
